<!--
  ~ Copyright 2022. NXGN Management, LLC. All Rights Reserved.
  -->

<app-header
  [menuCollapsed]="menuCollapsed"
  [isUserLogged]="isUserLogged"
  (menuCollapseEvent)="receiveMenuCollapseEvent($event)"
></app-header>
<div *ngIf="!menuCollapsed">
  <app-side-nav
    (menuCollapseEvent)="receiveMenuCollapseEvent($event)"
  ></app-side-nav>
</div>
